export const AGENDA_DESKTOP_MIN_PX = 1280;
export const AGENDA_TABLET_MIN_PX = 768;

export type AgendaViewport = "desktop" | "tablet" | "mobile";

export function resolveAgendaViewport(widthPx: number): AgendaViewport {
  if (widthPx >= AGENDA_DESKTOP_MIN_PX) {
    return "desktop";
  }
  if (widthPx >= AGENDA_TABLET_MIN_PX) {
    return "tablet";
  }
  return "mobile";
}
